import { render } from "./SettingsHeader.vue?vue&type=template&id=3396a5d8&scoped=true"
import script from "./SettingsHeader.vue?vue&type=script&lang=js"
export * from "./SettingsHeader.vue?vue&type=script&lang=js"

import "./SettingsHeader.vue?vue&type=style&index=0&id=3396a5d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3396a5d8"]])

export default __exports__